<template>
  <div id="cc-1919-app">
    <a v-on:click="openModal" class="cc-1919__open-modal-button">
      <span class="cc-1919__open-modal-button__icon">
        <!-- <img src="https://cdn.concertconsult.co.uk/1919-survey/speech_bubble_icon.svg" alt="bubble icon"> -->
        <span class="svg-container speech-bubble"><SpeechBubble/></span>
      </span><span class="button-text">Have your say</span></a>
    <div v-if="open" class="overlay" id="overlay">
      <transition
        mode="out-in"
        enter-active-class="bounceInLeft"
        leave-active-class="bounceOutRight"
      >
        <QuestionModalCurrent
          v-if="currentModal === 0"
          v-on:toggle-modal="currentModal = 1"
          :apiData="apiDataCurrent.data"
          @close-modal="closeModal"
        />
        <QuestionModalPrevious
          v-if="currentModal === 1"
          v-on:toggle-modal="currentModal = 0"
          :apiData="apiDataPrevious.data"
          @close-modal="closeModal"
        />
      </transition>
    </div>
  </div>
</template>

<script>

import QuestionModalCurrent from './components/QuestionModalCurrent.vue'
import QuestionModalPrevious from './components/QuestionModalPrevious.vue'

import SpeechBubble from './assets/speech-bubble.svg'

export default {
  name: 'cc-1919-app',
  components: {
    QuestionModalCurrent,
    QuestionModalPrevious,
    SpeechBubble
  },
  props: {
    clientId: String
  },
  data: function () {
    return {
      currentModal: 0,
      show: true,
      apiDataCurrent: {
        "data": {}
      },
      apiDataPrevious: {
        "data": {}
      },
      open: false,
      dataLoaded: false,
    }
  },
  methods: {
    closeModal () {
      this.open = false;
    },
    openModal () {
      this.open = true;
    },
    validateJson (json) {
      // Really basic validation. Needs improving.
      if (Object.keys(json).length > 0) {
        return true
      } else {
        return false;
      }
    }
  },
  beforeMount: function () {
    axios.get('https://api2.survey.concertstaging.co.uk/api/client/' + this.clientId + '/current' ).then(
      response => {
        if ( this.validateJson(response.data) ) {
          this.apiDataCurrent = response.data;
        } else {
          console.log('Current Q invalid JSON');
        }
      },
      this.dataLoaded = true
    ).catch((error) => {
      console.warn('Failed to load current question');
    });
    axios.get('https://api2.survey.concertstaging.co.uk/api/client/' + this.clientId + '/previous' ).then(
      response => {
        if ( this.validateJson(response.data) ) {
          this.apiDataPrevious = response.data;
        } else {
          console.log('Previous Q invalid JSON');
        }
      }
    ).catch((error) => {
      console.warn('Failed to load previous question');
    });

    var cssId = 'myCss';  // you could encode the css path itself to generate id..
    if (!document.getElementById(cssId))
    {
        var head  = document.getElementsByTagName('head')[0];
        var link  = document.createElement('link');
        link.id   = cssId;
        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://cdn.concertconsult.co.uk/hp-survey/' + this.clientId + '.css';
        // link.href = '/' + this.clientId + '.css'; // FOR DEV
        link.media = 'all';
        head.appendChild(link);
    }
  },
  mounted() {

  },
}
</script>

<style lang="scss">
@import './styles/basestyles.scss';
$animationDuration: 1s; // specify animation duration. Default value: 1s
@import "../node_modules/vue2-animate/src/sass/vue2-animate.scss";

</style>
